import JSEncrypt from 'jsencrypt'

class EncryptService {
  // 加密URL中的特定参数
  static encryptUrlParams = function (url, paramsToEncrypt = []) {
    if (!paramsToEncrypt)
      return url;

    // RSA加密
    const publicKey = `-----BEGIN PUBLIC KEY-----
    MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1HMoKfrZj7m07+Ttc/4o
    FTITbnirpz2Ml+YQAyehnrRQRVojcIF90jfK78TPwaOvWmooL1IMvM9LYzFfjnBQ
    nA9yzYtZBnJbcvUeVXV2CrmUvFZEfmAbmjVBZaaov6vtjJYxXjc3XIieimjYHjgy
    3umEeArpiWdDWIFPEgtQ8uid6b1a6b+14Gcogh0OMwFrrrF+UT1LIP767l5tUbPu
    enQZ8EKG7sOLoklQ5mFAOr+ThSMDGFKRcDqc+RcBWoPQuFayCCh3joXKi6Wa/ww1
    AesMZ36HWNDdxXvKiXiA/qOfCaQygYfETuUFooaLvPXV84a0e8RUUNHJXyc6Uijr
    GwIDAQAB
    -----END PUBLIC KEY-----`;
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(publicKey);

    const urlObj = new URL(url, window.location.origin);
    const params = new URLSearchParams(urlObj.search);

    let changed = false;
    // 加密特定参数
    for (const [key, value] of params.entries()) {
      // 检查参数是否在需要加密的列表中（忽略大小写）
      const shouldEncrypt = paramsToEncrypt.some(
        param => param.localeCompare(key, undefined, { sensitivity: 'accent' }) === 0
      );

      if (shouldEncrypt && value && !value.startsWith('enc:')) {
        const encryptedValue = encryptor.encrypt(value);
        if (encryptedValue) {
          params.set(key, 'enc:' + encryptedValue); // 不需要额外使用encodeURIComponent()编码
          changed = true;
        }
      }
    }

    if (changed) {
      urlObj.search = params.toString();
      return urlObj.toString();
    }

    return url;
  }
}

export default EncryptService



// WEBPACK FOOTER //
// ./src/common/js/encrypt.js